import React from 'react';
import ScreenHeader from '../components/ScreenHeader';
import ButtonTable from '../components/ButtonTable';
import logo from '../assets/i80logo.png';

function SelectLocation() {
  return (
    <div className="app-wide__container">
      <ScreenHeader message="Visit Now" />
      <div className="app-wide__add-new select-location__logo-row">
        <img className="select-location__logo" src={logo} alt="I-80 Gold logo" />
      </div>
      <div className="app-wide__main select-location__main">
        <p className="select-location__prompt">Select the location of your visit:</p>
        <ButtonTable />
      </div>
    </div>
  );
}

export default SelectLocation;
